import { useAvailableRoomById } from '@common/features/rooms';
import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { toCamelCaseAvailableRoom, toRoomAvailabilityParams } from './mappers';

export default function useAvailableRoom(id: string, journeyParams: ParsedJourneyParams) {
  const roomAvailabilityParams = toRoomAvailabilityParams(journeyParams);
  const { data, isFetching, error } = useAvailableRoomById({ id, ...roomAvailabilityParams });
  const availableRoom = data ? toCamelCaseAvailableRoom(data) : undefined;

  return {
    availableRoom,
    isFetching,
    error,
  };
}
